module.exports = __webpack_public_path__ + "img/loading-bubbles.a1807b84.svg";